import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'gtw-error-404',
    templateUrl: './error-404.component.html',
    styleUrls: ['./error-404.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class Error404Component {}
